module.exports = __webpack_public_path__ + "static/img/mer.41158c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/mer.jpg
// module id = sqyH
// module chunks = 0